// typescript
// `src/components/LazyVideo.tsx`
import React, { useEffect, useRef, useState } from "react";

interface LazyVideoProps {
    srcMp4?: string;
    srcWebm?: string;
    poster?: string;
    className?: string;
    loop?: boolean;
    muted?: boolean;
    autoPlay?: boolean;
}

export default function LazyVideo({
                                      srcMp4,
                                      srcWebm,
                                      poster,
                                      className,
                                      loop = false,
                                      muted = true,
                                      autoPlay = true,
                                  }: LazyVideoProps) {
    const ref = useRef<HTMLDivElement | null>(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setVisible(true);
                    obs.disconnect();
                }
            },
            { threshold: 0.2 }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, []);

    return (
        <div ref={ref} className={className}>
            {!visible ? (
                // poster shown and lazy-loaded
                <img src={poster} alt="preview" loading="lazy" className="w-full h-auto rounded-3xl shadow-2xl object-cover" />
            ) : (
                <video
                    className="w-full h-auto rounded-3xl shadow-2xl object-cover"
                    playsInline
                    muted={muted}
                    loop={loop}
                    autoPlay={autoPlay}
                    preload="auto"
                    poster={poster}
                >
                    {srcWebm && <source src={srcWebm} type="video/webm" />}
                    {srcMp4 && <source src={srcMp4} type="video/mp4" />}
                    {/* fallback: poster img will display in browsers without video */}
                </video>
            )}
        </div>
    );
}
